var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import * as S from './style-3';
import Image from '../../../components/loggedout/common/Image';
import { fetchImageUrlForNewOnboarding, getItemFromLocalStorage } from '../../../utils/web-helper';
export var LoadThroughScreenThree = function (props) {
    var ResourcesData = getItemFromLocalStorage('loadthrough-screen-3');
    var interval1;
    useEffect(function () {
        interval1 = setTimeout(function () {
            props.goToNextHandler('load_through_screen_3', {});
        }, 4000);
        return function () { return clearInterval(interval1); };
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(S.Heading, { children: "Finishing up with more exciting resources" }), _jsx(S.BaseBg, { children: ResourcesData['loadthrough-screen-3'].map(function (data, index) { return (_jsxs(S.ResourceWrapper, __assign({ top: data.top, left: data.left }, { children: [_jsx(S.ResourceIcon, { children: _jsx(Image, { src: fetchImageUrlForNewOnboarding(data.path, data.image), alt: "resource-icon" }) }), _jsx(S.ResourceText, { children: data.title })] }), index)); }) })] }));
};
export default LoadThroughScreenThree;
